import { Fade } from "react-awesome-reveal";
import Physical from "../../../homepage/physical";
import useStore from "../../../../features/store";
import BiologicalAgeImg from "../../../../assets/images/biological-age.png";
import TestTitle from "../../testCommon/TestTitle";
import SleepImage from "../../../../assets/images/sleep-image.png";
import StressImage from "../../../../assets/images/stress-image.png";
import PhysicalImage from "../../../../assets/images/physical-image.png";
import GeneralCheckImage from "../../../../assets/icons/general-check.png";
import { getAgeJalali } from "../../../../utils/Functions";

const GeneralHealth = ({ testInfo, testResults, footerButtons }: any) => {
  const { isLoadingBiorhythm, biorhythm }: any = useStore();
  const is_pro = testInfo.is_pro_analysis;

  const normaliseValue = (value: number | string) => {
    return Number(value) >= 100 ? 99 : value;
  };

  const OtherRhythms = (title: string, value: number, info: string) => {
    return (
      <div className="flex flex-col items-center justify-between p-5 rounded-lg bg-white flex-1 w-full">
        <div className="flex items-center justify-between w-full">
          <h5 className="font-rokh text-lg font-[900]">{title}</h5>
          <h6
            className="text-xl font-rokh text-xl font-[900]"
            style={{ direction: "ltr" }}
          >
            {normaliseValue(Math.round(value * 100))}
            <strong className="text-base">%</strong>
          </h6>
        </div>

        <p className="mt-1 text-sm text-right w-full">{info}</p>
      </div>
    );
  };

  return (
    <>
      <Fade triggerOnce>
        <div className="mt-2">
          <TestTitle
            title="بررسی وضعیت فیزیکی و سلامتی"
            subtitle="وضعیت استرس، خواب و فعالیت فیزیکی رو اینجا بررسی کردیم برات."
            icon={GeneralCheckImage}
          />

          <Fade triggerOnce>
            <div className="flex flex-col lg:flex-row mt-6 gap-2">
              <div className="relative mt-2 flex-1">
                <div className="flex-1 lg:min-h-[260px] p-8 bg-white border rounded-xl flex flex-col items-start">
                  <div>
                    <h1 className="font-[900] font-rokh text-lg lg:text-xl lg:mt-2">
                      وضعیت استرس
                    </h1>
                    {is_pro ? (
                      <p className="text-sm lg:mt-1">
                        {testResults?.medical_advice?.stress_state}
                      </p>
                    ) : (
                      <p className="text-sm lg:mt-1">
                        توی تحلیل پیشرفته، هوش‌مصنوعی بادی‌بان می‌تونه وضعیت
                        استرست رو با توجه به آزمایشت بررسی کنه و بهت دیدگاه خوبی
                        بده.
                      </p>
                    )}
                  </div>
                  <img
                    src={StressImage}
                    className="w-5/12 mr-auto -mb-8 -ml-10 hidden lg:flex"
                  />
                </div>
              </div>

              <div className="relative mt-2 flex-1">
                <div className="flex-1 lg:min-h-[260px] p-8 bg-white border rounded-xl flex flex-col items-start">
                  <div>
                    <h1 className="font-[900] font-rokh text-lg lg:text-xl lg:mt-2">
                      وضعیت خواب
                    </h1>
                    {is_pro ? (
                      <p className="text-sm lg:mt-1">
                        {testResults?.medical_advice?.sleep_state}
                      </p>
                    ) : (
                      <p className="text-sm lg:mt-1">
                        وضعیت خواب و استراحتت تاثیر زیادی داره روی وضعیت سلامتی
                        بدنت، توی تحلیل پیشرفته ما می‌تونیم اطلاعات خوبی در
                        موردش بهت بدیم.
                      </p>
                    )}
                  </div>
                  <img
                    src={SleepImage}
                    className="w-5/12 mr-auto lg:-mb-8 lg:-ml-10 -mb-5 -ml-5 hidden lg:flex"
                  />
                </div>
              </div>

              <div className="relative mt-2 flex-1">
                <div className="flex-1 lg:min-h-[260px] p-8 bg-white border rounded-xl flex flex-col items-start">
                  <div>
                    <h1 className="font-[900] font-rokh text-lg lg:text-xl lg:mt-2">
                      وضعیت فیزیکی
                    </h1>
                    {is_pro ? (
                      <p className="text-sm lg:mt-1">
                        {testResults?.medical_advice?.exirsise_level}
                      </p>
                    ) : (
                      <p className="text-sm lg:mt-1">
                        می‌دونی فعالیت فیزیکی چه تاثیر عجیبی روس سلامتیت داره؟
                        بادی‌بان می‌تونه بررسی کنه که شرایطتت توی این مورد
                        چجوریه.
                      </p>
                    )}
                  </div>
                  <img
                    src={PhysicalImage}
                    className="w-5/12 mr-auto lg:-mb-8 lg:-ml-10 -mb-5 -ml-5 hidden lg:flex"
                  />
                </div>
              </div>
            </div>
          </Fade>
        </div>

        <div className="flex flex-col lg:flex-row justify-between items-center gap-5 mt-5">
          <Physical
            weight={testInfo?.weight}
            height={testInfo?.height}
            bmi={testInfo?.bmi}
            test_id={testInfo.test_id}
            isResult={true}
          />

          <div className="flex-1 relative bg-pr_blue rounded-xl w-auto overflow-hidden px-5 py-10 lg:p-10">
            <img
              src={BiologicalAgeImg}
              className="absolute -left-2 bottom-0 w-4/12 hidden lg:block"
            />
            <h3 className="font-rokh font-[900] text-xl">سن بایولوژیک</h3>

            <p className="mt-3 text-sm">
              سن بیولوژیکی، که بهش سن زیستی هم می‌گن، نشون‌دهنده‌ی وضعیت سلامتی
              و عملکرد بدنتونه و ممکنه با سن شناسنامه‌ای‌تون فرق داشته باشه.
              عواملی مثل ژنتیک، سبک زندگی، رژیم غذایی، فعالیت بدنی و میزان استرس
              روی این سن تأثیر می‌ذارن. مثلاً، ممکنه دو نفر هر دو ۴۰ ساله باشن،
              ولی یکی سن بیولوژیکی ۳۵ و دیگری ۴۵ سال داشته باشه، که این نشون
              می‌ده بدنشون چقدر سالم‌تر یا پیرتر از سن واقعی‌شونه.{" "}
            </p>

            <div className="flex gap-3 w-full lg:w-4/6 mt-16">
              <div className="card flex-1 py-10 bg-white rounded-box grid h-32 flex-grow place-items-center">
                <h2 className="text-4xl font-rokh font-[900]">
                  {getAgeJalali(testInfo?.birth_day)}
                </h2>
                <p>سن حقیقی</p>
              </div>
              <div className="card flex-1 py-10 bg-white rounded-box grid h-32 flex-grow place-items-center">
                {is_pro ? (
                  <h2 className="text-4xl font-rokh font-[900] min-h-[40px]">
                    {Math.round(testResults?.biological_age)}
                  </h2>
                ) : (
                  <h2 className="text-base font-rokh font-[700] min-h-[40px]">
                    تحلیل پیشرفته
                  </h2>
                )}
                <p>سن بایولوژیکی</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 relative bg-pr_yellow rounded-xl w-auto overflow-hidden mt-5 px-5 py-10 lg:p-10">
          <h3 className="font-rokh font-[900] text-xl"> بایوریتم</h3>

          <p className="font-rokh font-[700]">
            به کمک منحنی بایوریتم، تاثیر ریتم‌های زندگیت رو بررسی کن و چک کن
            ببین امروز حالت چطوره!
          </p>

          {biorhythm && (
            <div className="mt-10">
              <div className="grid grid-cols-1 lg:grid-cols-3 mt-5 mb-2 gap-2">
                {OtherRhythms(
                  "ذهنی",
                  Number(Number(biorhythm?.intellectual).toFixed(2)),
                  "چرخه ۳۳ روزه بیوریتم بر هوش، حافظه و واکنش‌ها تأثیر می‌گذارد."
                )}

                {OtherRhythms(
                  "احساسی",
                  Number(Number(biorhythm?.emotional).toFixed(2)),
                  "چرخه احساسی ۲۸ روزه مربوطه که تأثیر زیادی روی روحیه و روابط"
                )}

                {OtherRhythms(
                  "فیزیکی",
                  Number(Number(biorhythm?.physical).toFixed(2)),
                  "چرخه ۲۳ روزه انرژی جسمی‌ات باعث اوج و فرودهای بدنی می‌شه، این چرخه روی توان جسمی و مقاومت بدن تأثیر می‌ذاره. "
                )}
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-2">
                {OtherRhythms(
                  "زیبایی‌شناسی",
                  Number(Number(biorhythm?.aesthetic).toFixed(2)),
                  "چرخه 43 روزه و به درک زیبایی در هنر و طبیعت مربوط می‌شود"
                )}

                {OtherRhythms(
                  "آگاهی",
                  Number(Number(biorhythm?.awareness).toFixed(2)),
                  "چرخه 48 روزه و بر میزان توجه و هوشیاری فرد تأثیر می‌گذارد."
                )}

                {OtherRhythms(
                  "شهودی",
                  Number(Number(biorhythm?.spiritual).toFixed(2)),
                  "چرخه 38 روزه و به توانایی دریافت و تفسیر احساسات و الهامات ربط دارد."
                )}

                {OtherRhythms(
                  "معنوی",
                  Number(Number(biorhythm?.aesthetic).toFixed(2)),
                  " چرخه 53 روزه به درک و ارتباطات معنوی و احساسی عمیق اشاره دارد."
                )}
              </div>
            </div>
          )}
        </div>
      </Fade>

      {footerButtons}
    </>
  );
};

export default GeneralHealth;
